"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var EAdvertisingDialog;
(function (EAdvertisingDialog) {
  EAdvertisingDialog["CacheBackDialog"] = "CacheBackDialog";
  EAdvertisingDialog["PhoneNumberDialog"] = "PhoneNumberDialog";
  EAdvertisingDialog["Application"] = "Application";
  EAdvertisingDialog["AutomaticApplication"] = "AutomaticApplication";
  EAdvertisingDialog["BusinessLoansApiRequest"] = "BusinessLoansApiRequest";
  EAdvertisingDialog["ApiRequest"] = "ApiRequest";
  EAdvertisingDialog["ProjectApiAgents"] = "ApiAgents";
  EAdvertisingDialog["LeasingApiRequest"] = "LeasingApiRequest";
  EAdvertisingDialog["LeasingApiRequestAlfa"] = "LeasingApiRequestAlfa";
  EAdvertisingDialog["LeasingApiRequestVtb"] = "LeasingApiRequestVtb";
  EAdvertisingDialog["ApiBankruptcy"] = "ApiBankruptcy";
  EAdvertisingDialog["ApiAcquiring"] = "ApiAcquiring";
  EAdvertisingDialog["LeasingRequestSending"] = "LeasingRequestSending";
  EAdvertisingDialog["ApiBusinessRegistration"] = "ApiBusinessRegistration";
  EAdvertisingDialog["ApiAccountingServices"] = "ApiAccountingServices";
  EAdvertisingDialog["AccountingForAC"] = "AccountingForAC";
  EAdvertisingDialog["ApiAutoLeasing"] = "ApiAutoLeasing";
  EAdvertisingDialog["ApiBankGuarantees"] = "ApiBankGuarantees";
  EAdvertisingDialog["ApiApplicationRosAgroLeasing"] = "ApiApplicationRosAgroLeasing";
  EAdvertisingDialog["SberFactoringDialog"] = "SberFactoringDialog";
  EAdvertisingDialog["KubanCreditBank"] = "KubanCreditBank";
  EAdvertisingDialog["DmsVsk"] = "dmsVsk";
  EAdvertisingDialog["rshbAgentsDialog"] = "rshbAgentsDialog";
  EAdvertisingDialog["redGate"] = "redGate";
  EAdvertisingDialog["KSKFactoring"] = "KSKFactoring";
  EAdvertisingDialog["FlowBusinessCreditDialog"] = "FlowBusinessCreditDialog";
  EAdvertisingDialog["HomeInternetApplication"] = "HomeInternetApplication";
  EAdvertisingDialog["CreditEuropeBankAcquiring"] = "CreditEuropeBankAcquiring";
  EAdvertisingDialog["DmsRenaissance"] = "dmsRenaissance";
  EAdvertisingDialog["MetallinvestbankCreditForBusiness"] = "MetallinvestbankCreditForBusiness";
})(EAdvertisingDialog || (EAdvertisingDialog = {}));
var _default = EAdvertisingDialog;
exports.default = _default;